import { useAppDispatch, useShowSearchMetaTooltip } from 'shared/hooks';
import { FC, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAnalytics, useDatesChangeHandler } from './hooks';
import { selectDatesFilter } from 'shared/selectors/filters';
import { DropdownDates, DropdownFilter, useDropdown } from 'shared/components/DropdownFilter';
import { FILTER_KEY } from './constants';
import { trackCloseDatesModal, trackOpenDatesModal } from './tracking';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';
import { selectDatesPopupOpened } from 'shared/selectors/modals';
import { setDatesPopupOpen } from 'shared/slices/modal';

export const DatesContainer: FC = () => {
  const {
    label,
    value: { from, to },
    min,
    max,
    size,
  } = useSelector(selectDatesFilter);

  const dispatch = useAppDispatch();

  const onChange = useDatesChangeHandler();

  const { opened, onClose, onOpen } = useDropdown(FILTER_KEY);

  const showTooltip = useShowSearchMetaTooltip(FILTER_KEY);

  const isDatesPopupOpened = useSelector(selectDatesPopupOpened);

  const handleOpen = useCallback(() => {
    onOpen();
    trackOpenDatesModal();
  }, [onOpen]);

  const handleClose = useCallback(() => {
    onClose();
    dispatch(setDatesPopupOpen(false));
    trackCloseDatesModal();
  }, [onClose, dispatch]);

  useAnalytics();

  useEffect(() => {
    if (isDatesPopupOpened) {
      handleOpen();
    }
  }, [isDatesPopupOpened, handleOpen]);

  const isFiltersRedesignEnabled = useSelector(selectIsInlineFiltersRedesigned);

  return (
    <DropdownFilter
      opened={opened}
      onOpen={handleOpen}
      onClose={handleClose}
      showTooltip={showTooltip}
      buttonLabel={label}
      isFiltersRedesignEnabled={isFiltersRedesignEnabled}
      dropdownContent={<DropdownDates valueTo={to} valueFrom={from} max={max} min={min} onChange={onChange} />}
      size={size}
    />
  );
};
